// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/" + ({"58":"form-validation","135":"infographic","139":"table-graph","143":"app","326":"hero-brands-slider","329":"carousel","369":"brandList","371":"stock-graph","516":"video-player","602":"animationAOS","914":"cardCollection"}[chunkId] || chunkId) + ".js";
};